import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'wo-notification-warning',
  templateUrl: './notification-warning.component.html',
  styleUrls: [ './notification-warning.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    IconComponent,
  ],
})
export class NotificationWarningComponent {
  @Input() public severity: 'major' | 'critical' | 'wait' = 'major';

  public get icon(): IconName {
    switch (this.severity){
      case 'major': return 'notice-warning';
      case 'wait': return 'clock';
      default: return 'error-notification';
    }
  }
}
